module.exports = __webpack_public_path__ + "img/EnumaGroupPhoto1600-2-1024x619.6b6a6f21.jpeg";